"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const TxTypes = {
    UpdateProfile: "profile/UpdateProfile",
};
const MsgUpdateProfile = {
    aminoType: TxTypes.UpdateProfile,
    valueMap: {},
};
const updateProfileProcess = {
    toAminoProcess: (amino, input) => {
        const newInput = input;
        if (input.twitter === "") {
            delete newInput.twitter;
        }
        return { amino, input: newInput };
    },
    fromAminoProcess: (amino, input) => {
        const newInput = input;
        if (!input.twitter) {
            newInput.twitter = "";
        }
        return { amino, input: newInput };
    },
};
const ProfileAmino = {
    [CarbonTx.Types.MsgUpdateProfile]: utils_1.generateAminoType(MsgUpdateProfile, updateProfileProcess),
};
exports.default = ProfileAmino;
